import { render, staticRenderFns } from "./PdpProductPrice.vue?vue&type=template&id=5d1e6324&"
import script from "./PdpProductPrice.vue?vue&type=script&lang=js&"
export * from "./PdpProductPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports